import React from 'react';
import useUserFormHelper from '@eogile/agrements-common/src/user/details/hooks/useUserFormHelper';
import { FdjUser } from '../../fdjUserTypes';
import { FdjUserFormValues } from '../fdjUserFormTypes';
import { computeUnselectableProfiles, sortedProfileCodes, toApiSaveCommand, toFormValues } from '../fdjUserFormUtils';
import { Card, CardContent, Grid } from '@mui/material';
import UserCardHeader from '@eogile/agrements-common/src/user/details/components/UserCardHeader';
import { Form } from 'react-final-form';
import UserCommonFields from '@eogile/agrements-common/src/user/details/components/UserCommonFields';
import UserProfileCheckboxes from '@eogile/agrements-common/src/user/details/components/UserProfileCheckboxes';
import UserCardActions from '@eogile/agrements-common/src/user/details/components/UserCardActions';
import { fdjProfileDisplayLabels } from '../../fdjUserUtils';
import { fdjCivilityLabels } from '../../../utils/fdjLabelUtils';
import FdjUserAgencyField from './FdjUserAgencyField';

const FdjUserForm = () => {
  const { initialValues, submitUserForm } = useUserFormHelper<FdjUser, FdjUserFormValues>({
    computeInitialValues: toFormValues,
    toApiUserSaveCommand: toApiSaveCommand,
  });

  const onSubmit = (values: FdjUserFormValues) => {
    return submitUserForm(values);
  };

  return (
    <Card>
      <UserCardHeader initialFormValues={initialValues} />
      <Form<FdjUserFormValues> initialValues={initialValues} onSubmit={onSubmit}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <CardContent>
              <Grid container columnSpacing={6}>
                <Grid container item rowSpacing={2} direction="column" xs={12} sm={6}>
                  <UserCommonFields civilityLabels={fdjCivilityLabels} />
                </Grid>
                <Grid container item rowSpacing={2} direction="column" xs={12} sm={6}>
                  <Grid item>
                    <UserProfileCheckboxes
                      profileCodes={sortedProfileCodes}
                      profileNames={fdjProfileDisplayLabels}
                      computeUnselectableProfiles={computeUnselectableProfiles}
                    />
                  </Grid>
                  <Grid item>
                    <FdjUserAgencyField />
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <UserCardActions />
          </form>
        )}
      </Form>
    </Card>
  );
};

export default FdjUserForm;
